import React, { useEffect, useState } from "react";
import { Button, DatePicker, Select, Table, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { EyeFilled } from "@ant-design/icons";
import "../../css/common.css";
import { post } from "../../../services/services";
import { ApiURL, bunkerpdfdownloadUrl } from "../../../services/apiConstants";
import VoyageDetails from "../../../components/VoyageDetails";
import useVoyageList from "../../../hooks/useVoyageList";
import { DOWNLOADPDF } from "../../../utils/downloadPdf";
import dayjs from "dayjs";
import { dateRanges } from "../../../Data/data";
const { RangePicker } = DatePicker;

const ListBunkerReport = () => {
  const navigate = useNavigate();
  const { voyageList } = useVoyageList();
  const [page_loader, set_page_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [voyage_ids, set_voyage_id] = useState("");
  const [voyage_status, set_voyage_status] = useState(true);
  const [dates, setDates] = useState([dayjs().subtract(2, "day"), dayjs()]);
  const [startDate, endDate] = dates?.map((d) => d.format("YYYY-MM-DD"))||[];

  useEffect(() => {
    if (voyageList?.length > 0) {
      const runningVoyage = voyageList.find((voyage) => voyage.voyage_status === true);
      set_voyage_status(runningVoyage?.voyage_status);
      if (runningVoyage) {
        set_voyage_id(runningVoyage.id);
        if (runningVoyage.id) LIST_BUNKER_LOGBOOK_API(runningVoyage.id);
      }
    }
  }, [voyageList]);

  const LIST_BUNKER_LOGBOOK_API = (voyage_id) => {
    set_page_loader(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("voyage_id", voyage_id);
    try {
      post(ApiURL.bunker_tank_entries, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setFilteredData(res?.entries);
          set_page_loader(false);
        } else {
          set_page_loader(false);
        }
      });
    } catch (error) {
      console.error("Error fetching Staff list:", error);
      set_page_loader(false);
    }
  };

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
    if (voyage_ids) LIST_BUNKER_LOGBOOK_API(voyage_ids);
  }, []);

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      align: "center",
      key: "id",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Place",
      dataIndex: "place",
      align: "center",
      key: "place",
    },
    {
      title: "Log Date",
      dataIndex: "log_date",
      align: "center",
      key: "log_date",
    },
    {
      title: "Log Time",
      dataIndex: "log_time",
      align: "center",
      key: "log_time",
    },

    {
      title: "Action",
      align: "center",
      key: "Action",
      render: (text, record) => (
        <Tooltip title="View">
          <Button
            type="primary"
            size="small"
            onClick={() => navigate(`/view-bunker-record/${btoa(record?.id)}`)}
            style={{ marginRight: "5px" }}
            icon={<EyeFilled />}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <>
      <VoyageDetails
        staff_dashboard={staff_dashboard?.voyage_details}
        buttonShow={true}
        disabled={!voyage_status}
        buttonProps={{
          text: "Add Logs",
          className: "save_btn",
          onClick: () => navigate("/add-bunker-record"),
          onPress: () => navigate("/audit-trail-bunker-record"),
        }}
      />

      <div className="row">
        <div className="col-3" style={{ marginBottom: "13px", marginLeft: "15px" }}>
          <label className="block-label">Select Voyage Id</label>
          <Select
            placeholder="---- Select Voyage Id ----"
            style={{ width: "100%" }}
            value={voyage_ids}
            onChange={(value) => {
              const selectedVoyage = voyageList.find((voyage) => voyage.id === value);
              if (selectedVoyage) {
                set_voyage_status(selectedVoyage.voyage_status);
              }
              set_voyage_id(value);
              LIST_BUNKER_LOGBOOK_API(value);
            }}
          >
            {voyageList?.map((voyage) => (
              <Select.Option key={voyage.id} value={voyage.id}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span>{`Voyage Id: ${voyage.id}`}</span>
                  <span
                    style={{
                      color: voyage.voyage_status === true ? "#FFA500" : "#008000",
                      fontWeight: "550",
                      marginRight: "15px",
                    }}
                  >
                    {voyage.voyage_status === true ? "Running" : "Complete"}
                  </span>
                </div>
              </Select.Option>
            ))}
          </Select>
        </div>

        <div className="col-3"></div>
        <div className="col-6" style={{ display: "flex", justifyContent: "flex-end" }}>
          <div style={{ marginRight: "15px" }}>
            <label className="block-label">Select Start Date & End Date</label>
            <RangePicker
              presets={dateRanges}
              value={dates}
              onChange={setDates}
              format="YYYY-MM-DD"
              style={{ width: 350 }}
              disabledDate={(current) => current && current > dayjs().endOf("day")}
            />
          </div>
          <div style={{ alignSelf: "flex-end" }}>
            <Button
              type="primary"
              className="save_btn"
              style={{ color: "white", marginBottom: "13px" }}
              onClick={() => DOWNLOADPDF(bunkerpdfdownloadUrl, voyage_ids, startDate, endDate)}
            >
              Download Pdf
            </Button>
          </div>
        </div>
      </div>
      <Table
        bordered
        columns={columns}
        dataSource={filteredData}
        pagination={{ pageSize: 10 }}
        rowKey="key"
        loading={page_loader}
        className="custom-table"
      />
    </>
  );
};

export default ListBunkerReport;
